console.log('top');
// ______________________________________

// Lenis
let lenis = null;
let tickerFn = null;

const mm = gsap.matchMedia();

mm.add("(max-width: 768px)", () => {
    lenis = new Lenis();
    lenis.on("scroll", ScrollTrigger.update);

    tickerFn = (time) => {
        lenis.raf(time * 1000);
    };
    gsap.ticker.add(tickerFn);

    gsap.ticker.lagSmoothing(0);

    return () => {
        if (tickerFn) gsap.ticker.remove(tickerFn);
        tickerFn = null;

        if (lenis) {
            lenis.stop?.();
            lenis.destroy?.();
            lenis = null;
        }

        ScrollTrigger.refresh();
    };
});

// ______________________________________

// ローディング画面

$(function () {
    function getCurrentVideo() {
        const isSp = window.matchMedia('(max-width: 767px)').matches;
        return document.querySelector(`.mainVideo.${isSp ? '_sp' : '_pc'}`);
    }

    function startMainVideo() {
        const v = getCurrentVideo();
        if (!v) return;

        const src = v.dataset.src;

        if (src && !v.getAttribute('src')) {
            v.setAttribute('src', src);
            v.load();
        }
        v.classList.remove('fade-hidden');
        v.pause();
        v.currentTime = 0;

        const p = v.play();
        if (p && typeof p.catch === 'function') p.catch(() => { });
    }

    function end_loader() {
        $('.loader').fadeOut(800, function () {
            startMainVideo();
        });
    }

    $(window).on('load', function () {
        setTimeout(function () {
            end_loader();
        }, 2000);
    });
});

// ______________________________________

// top動画

const skipBtn = document.getElementById('skipBtn');
const replayBtn = document.getElementById('replayBtn');

function fadeOut(el) {
    el.classList.add('fade-hidden');
}
function fadeIn(el) {
    el.classList.remove('fade-hidden');
}

// SP/PC 判定して対象を取得
function getCurrentElements() {
    const isSp = window.matchMedia('(max-width: 767px)').matches;
    const video = document.querySelector(`.mainVideo.${isSp ? '_sp' : '_pc'}`);
    const img = document.querySelector(`.skipImage.${isSp ? '_sp' : '_pc'}`);
    const note = document.querySelector('.com-imgnote');
    return { video, img, note };
}

// 「動画→画像」＋「ボタンをSKIP→REPLAY」
function showSkipImage() {
    const { video, img, note } = getCurrentElements();
    if (!video || !img) return;

    fadeOut(video);
    fadeIn(img);
    if (note) fadeIn(note);

    skipBtn.style.display = 'none';
    replayBtn.style.display = 'inline-block';
}

// 「画像→動画」＋「ボタンをREPLAY→SKIP」
function replayVideo() {
    const { video, img, note } = getCurrentElements();
    if (!video || !img) return;

    fadeOut(img);
    fadeIn(video);
    if (note) fadeOut(note);

    video.pause();
    video.currentTime = 0;
    video.play();

    skipBtn.style.display = 'inline-block';
    replayBtn.style.display = 'none';
}

// ______________________________________
// 動画読み込み設定
function loadResponsiveVideos() {
    const isSp = window.matchMedia('(max-width: 767px)').matches;
    const targetClass = isSp ? '_sp' : '_pc';

    document.querySelectorAll('video').forEach(video => {
        const shouldLoad = video.classList.contains(targetClass);
        const src = video.dataset.src;

        if (shouldLoad && src && !video.src) {
            video.src = src;
            video.load();
        }
    });
}
window.addEventListener('DOMContentLoaded', loadResponsiveVideos);

function initMainVideoVisibility() {
    const isSp = window.matchMedia('(max-width: 767px)').matches;

    document.querySelectorAll('.mainVideo').forEach(video => {
        if (video.classList.contains(isSp ? '_sp' : '_pc')) {
            video.classList.remove('fade-hidden');
        } else {
            video.classList.add('fade-hidden');
        }
    });
}
window.addEventListener('DOMContentLoaded', initMainVideoVisibility);

// 
const videoObserver = new IntersectionObserver(entries => {
    entries.forEach(entry => {
        if (!entry.isIntersecting) return;

        const video = entry.target;
        const src = video.dataset.src;

        if (src && !video.src) {
            video.src = src;
            video.load();

            if (video.autoplay) {
                video.play().catch(() => { });
            }
        }

        videoObserver.unobserve(video);
    });
}, {
    rootMargin: '300px'
});

document.querySelectorAll('.js-responsive-video').forEach(video => {
    const isSp = window.matchMedia('(max-width: 767px)').matches;
    const shouldObserve = video.classList.contains(isSp ? '_sp' : '_pc');

    if (shouldObserve) {
        videoObserver.observe(video);
    }
});
// ______________________________________

// 初期化
window.addEventListener('DOMContentLoaded', () => {
    // 画像、キャプションは最初は非表示
    document.querySelectorAll('.skipImage').forEach(img => img.classList.add('fade-hidden'));
    const note = document.querySelector('.com-imgnote');
    if (note) note.classList.add('fade-hidden');
    // REPLAYボタン非表示（CSSでもOKだけど念のため）
    replayBtn.style.display = 'none';

    // ボタンイベント
    skipBtn.addEventListener('click', showSkipImage);
    replayBtn.addEventListener('click', replayVideo);

    // 動画が最後まで行ったら自動で showSkipImage()
    document.querySelectorAll('.mainVideo').forEach(video => {
        video.addEventListener('ended', showSkipImage);
    });
});

// （既存の fade-text 処理が必要ならそのまま）
document.querySelectorAll('.fade-text').forEach(el => {
    const text = el.textContent;
    el.innerHTML = [...text].map(char => `<span>${char}</span>`).join('');
});

// ______________________________________

// コンセプト部分背景切り替え
$(function () {
    const $target = $(".concept");
    const $conceptBg = $("#bg-concept");
    const $html = $("html");

    $(window).on("load scroll resize", function () {
        const wh = $(window).height();
        const scroll = $(window).scrollTop();

        const top = $target.offset().top;
        const h = $target.outerHeight();

        const inPoint = wh * 0.5;
        const outPoint = wh * 0.6;

        const isIn =
            scroll + wh >= top + inPoint &&
            scroll + wh < top + h + outPoint;

        if (isIn) {
            $conceptBg.addClass("is-on");
            $html.addClass("is-concept");
        } else {
            $conceptBg.removeClass("is-on");
            $html.removeClass("is-concept");
        }
    });
});

// ______________________________________

gsap.registerPlugin(ScrollTrigger);

const sequence = document.querySelector("[data-top-sequence]");
const conceptInner = document.querySelector(".topcontent.concept [data-section-inner]");
const locationInner = document.querySelector(".topcontent.location [data-section-inner]");
const accessInner = document.querySelector(".topcontent.access [data-section-inner]");
const conceptTextbox = document.querySelector(".topcontent.concept .textbox"); // textbox取得

// ===== メディアクエリ判定 =====
const PC_BREAKPOINT = 769;
let st = null;
let tl = null;
let step = 0;
let isAnimating = false;
let lockY = null;
let isLocked = false;
let rafId = null;

function isPC() {
    return window.innerWidth >= PC_BREAKPOINT;
}

function setOverlayMode() {
    gsap.set(conceptInner, {
        position: "fixed",
        inset: 0,
        zIndex: 1,
        force3D: true
    });
    gsap.set(locationInner, {
        position: "fixed",
        inset: 0,
        zIndex: 2,
        force3D: true
    });
    gsap.set(accessInner, {
        position: "fixed",
        inset: 0,
        zIndex: 3,
        force3D: true
    });
}

function clearOverlayMode() {
    gsap.set([conceptInner, locationInner, accessInner], {
        clearProps: "position,inset,zIndex,force3D"
    });
}

// ===== スクロールロック（最適化版） =====
function preventScroll(e) {
    if (!isPC()) return;
    e.preventDefault();
}

function keepScroll() {
    if (lockY == null) return;

    const currentY = window.pageYOffset || document.documentElement.scrollTop;
    if (Math.abs(currentY - lockY) > 1) {
        window.scrollTo(0, lockY);
    }
}

function lockScroll(y) {
    lockY = y;
    if (isLocked) return;
    isLocked = true;

    window.addEventListener("wheel", preventScroll, { passive: false });
    window.addEventListener("touchmove", preventScroll, { passive: false });

    function loop() {
        if (isLocked) {
            keepScroll();
            rafId = requestAnimationFrame(loop);
        }
    }
    rafId = requestAnimationFrame(loop);
}

function unlockScroll() {
    lockY = null;
    if (!isLocked) return;
    isLocked = false;

    window.removeEventListener("wheel", preventScroll);
    window.removeEventListener("touchmove", preventScroll);

    if (rafId) {
        cancelAnimationFrame(rafId);
        rafId = null;
    }
}

// ===== スクロール設計（各セクション100vh待ち） =====
const WAIT1_VH = 100;
const WAIT2_VH = 100;
const END_WAIT_VH = 100;
const PIN_VH = WAIT1_VH + WAIT2_VH + END_WAIT_VH;

function thresholdY(st, vh) {
    return st.start + window.innerHeight * (vh / 100);
}

function runTo(label, y) {
    isAnimating = true;
    lockScroll(y);
    tl.tweenTo(label, {
        duration: 0.6,
        ease: "none",
        onComplete() {
            unlockScroll();
            isAnimating = false;
        }
    });
}

// ===== PC用アニメーション初期化 =====
function initPCAnimation() {
    // タイムライン作成（Safari最適化）
    tl = gsap.timeline({
        paused: true,
        smoothChildTiming: true
    });

    tl.addLabel("concept")
        .to(locationInner, {
            yPercent: 0,
            opacity: 1,
            duration: 0.6,
            ease: "power2.out",
            force3D: true
        })
        .addLabel("location")
        .to(accessInner, {
            yPercent: 0,
            opacity: 1,
            duration: 0.6,
            ease: "power2.out",
            force3D: true
        })
        .addLabel("access");

    // 初期状態設定（transform3dを使用）
    setOverlayMode();
    gsap.set(locationInner, {
        yPercent: 100,
        opacity: 0,
        force3D: true
    });
    gsap.set(accessInner, {
        yPercent: 100,
        opacity: 0,
        force3D: true
    });

    // ScrollTrigger作成
    st = ScrollTrigger.create({
        trigger: sequence,
        start: "top top",
        end: () => "+=" + window.innerHeight * (PIN_VH / 100),
        pin: true,
        scrub: false,
        anticipatePin: 1,
        fastScrollEnd: true,
        onEnter: setOverlayMode,
        onEnterBack: setOverlayMode,
        onLeave: clearOverlayMode,
        onLeaveBack: clearOverlayMode,
        onUpdate(self) {
            if (isAnimating) return;
            const passedVh = ((self.scroll() - self.start) / window.innerHeight) * 100;

            // ===== .textboxのスクロール連動 =====
            // conceptセクション内（0〜100vh）でtextboxを上に移動（下→上スクロール時のみ）
            if (passedVh < WAIT1_VH && conceptTextbox && self.direction === 1) {
                // 下→上スクロール（direction: 1）の時だけ動かす
                const progress = passedVh / WAIT1_VH; // 0〜1の進行度
                const moveDistance = progress * 100; // 0〜100%移動
                gsap.set(conceptTextbox, {
                    yPercent: -moveDistance,
                    force3D: true
                });
            }

            if (step === 0 && passedVh >= WAIT1_VH) {
                step = 1;
                runTo("location", thresholdY(self, WAIT1_VH));
                return;
            }

            if (step === 1 && passedVh >= (WAIT1_VH + WAIT2_VH)) {
                step = 2;
                runTo("access", thresholdY(self, WAIT1_VH + WAIT2_VH));
                return;
            }

            if (step === 2 && passedVh < (WAIT1_VH + WAIT2_VH)) {
                step = 1;
                runTo("location", thresholdY(self, WAIT1_VH + WAIT2_VH));
                return;
            }

            if (step === 1 && passedVh < WAIT1_VH) {
                step = 0;
                runTo("concept", thresholdY(self, WAIT1_VH));
                // conceptに戻るときはtextboxを0にリセット（上→下スクロール時）
                if (conceptTextbox) {
                    gsap.set(conceptTextbox, {
                        yPercent: 0,
                        force3D: true
                    });
                }
                return;
            }
        }
    });
}

// ===== PC用アニメーション破棄 =====
function destroyPCAnimation() {
    if (st) {
        st.kill();
        st = null;
    }
    if (tl) {
        tl.kill();
        tl = null;
    }
    unlockScroll();
    clearOverlayMode();
    gsap.set([locationInner, accessInner], { clearProps: "all" });
    if (conceptTextbox) {
        gsap.set(conceptTextbox, { clearProps: "all" });
    }
    step = 0;
    isAnimating = false;
}

// ===== レスポンシブ対応 =====
let resizeTimer = null;
function handleResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
        if (isPC()) {
            if (!st) {
                initPCAnimation();
            }
        } else {
            if (st) {
                destroyPCAnimation();
            }
        }
        ScrollTrigger.refresh();
    }, 100);
}

// 初期化
if (isPC()) {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initPCAnimation);
    } else {
        initPCAnimation();
    }
}

// リサイズ監視
window.addEventListener("resize", handleResize);

// Safari用：ページ表示時の強制リフレッシュ
window.addEventListener("pageshow", (event) => {
    if (event.persisted) {
        ScrollTrigger.refresh();
    }
});

// ______________________________________

// コンセプト画像パララックス
gsap.registerPlugin(ScrollTrigger);
const items = gsap.utils.toArray(".js-trigger");
items.forEach((item) => {
    const imgs = item.querySelectorAll("img");
    imgs.forEach((img) => {
        gsap.fromTo(
            img,
            { yPercent: 0 },
            {
                yPercent: -20,// 上に要素の幅の1/5分移動
                ease: "none",
                scrollTrigger: {
                    trigger: item,
                    start: "top bottom",
                    end: "bottom top",
                    scrub: 1,
                },
            }
        );
    });
});
// ______________________________________

// 下固定エントリーボタン
// let lastScrollTop = 0;
// let scrollUpDistance = 0;
// let scrollDownDistance = 0;

// const btn = document.querySelector('.bottom_btn');

// window.addEventListener('scroll', () => {
//     const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
//     const threshold = window.innerHeight * 0.3; // 10vh

//     if (scrollTop < lastScrollTop) {
//         // 上スクロール
//         scrollUpDistance += lastScrollTop - scrollTop;
//         scrollDownDistance = 0;

//         if (scrollUpDistance > threshold) {
//             btn.classList.add('is-show');
//         }
//     } else if (scrollTop > lastScrollTop) {
//         // 下スクロール
//         scrollDownDistance += scrollTop - lastScrollTop;
//         scrollUpDistance = 0;

//         if (scrollDownDistance > threshold) {
//             btn.classList.remove('is-show');
//         }
//     }

//     lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
// });
// ______________________________________

